import React from 'react';
import { useState } from 'react';
import { UseAppSelector, UseAppDispatch } from '../../../store/hooks';
import { toggleChecked, calcBE, calcDPU, calcDPH, calcPP, calcSV } from '../../../store/statsEngine';
import { BarChart, CurrencyDollar, BoxSeam, Diagram2 } from 'react-bootstrap-icons';
import OptimalBusinessModal from '../../flex/calculators/optimalBusinessModal';
import Fade from 'react-reveal/Fade';

import '../../../styles/desktop/calculators/businessStatsDashboard.css';

function BusinessStatsDashboard() {
    const dispatch = UseAppDispatch();

    // UI states
    const [dashboardState, setDashboardState] = useState('performance');
    const [modalShow, setModalShow] = useState(false);

    // redux
    const statsEngine = UseAppSelector((state) => state.stats);
    const dataObject = statsEngine.find(item => item.id === 21);
    const data = dataObject.data;
    
    const selectedDashboard = statsEngine.find(item => item.category === dashboardState);

    const sellOption = data.find(item => item.title === 'sell-close-far');
    const supplyOption = data.find(item => item.title === 'buy-steal-supplies');
    const saleValues = data.find(item => item.title === 'sale-values');
    const DPUValues = data.find(item => item.title === 'DPU-values');

    // click handlers
    function handleChecked(id) {
        const checkedState = statsEngine.find(item => item.id === id);
        dispatch(toggleChecked({ id: id, checked: !checkedState.checked }));
    }
    
    function handleSaleToggle(id, data, SV_data, DPU_data) {
        handleChecked(id);
        dispatch(calcDPU({ data: DPU_data }));
        dispatch(calcDPH({}));
        dispatch(calcSV({ data: SV_data }));
        dispatch(calcBE({ id: id, data: data }));
        dispatch(calcPP({}));
    }

    function handleSupplyToggle(id, data, SV_data) {
        handleChecked(id);
        dispatch(calcSV({ data: SV_data }));
        dispatch(calcBE({ id: id, data: data }));
        dispatch(calcPP({}));
    }

    return (
        <section className="stats-section">
            <Fade bottom cascade>
                <div>
                    <div className="stats-title">
                        <h2>- Business Stats Dashboard -</h2>
                        <p>View all of the statistics generated based on you selections!</p>
                    </div>
                </div>

                <div className="parent">
                    <div className="sidebar">
                        <div className="stats-filter">
                            <input type="radio" value="performance" onClick={e => setDashboardState(e.target.value)} name="filter-opt-a" id="opt-1a" defaultChecked></input>
                            <label htmlFor="opt-1a">
                                <BarChart className="svg"/>
                                <p>Performance</p>
                            </label>
                        
                            <input type="radio" value="costs" onClick={e => setDashboardState(e.target.value)} name="filter-opt-a" id="opt-2a"></input>
                            <label htmlFor="opt-2a">
                                <CurrencyDollar className="svg"/>
                                <p>Costs</p>
                            </label>
                        
                            <input type="radio" value="sales-supply" onClick={e => setDashboardState(e.target.value)} name="filter-opt-a" id="opt-3a"></input>
                            <label htmlFor="opt-3a">
                                <BoxSeam className="svg"/>
                                <p>Sales/Supply</p>
                            </label>
                        </div>
                        <hr/>
                        <div className="metric-modifiers">
                            <button type="button" className="optimize-btn" onClick={() => setModalShow(true)}>
                                <Diagram2 className="svg"/>
                                <p>Optimal Business</p>
                            </button>
                            
                            <div>
                                <OptimalBusinessModal show={modalShow} onHide={() => setModalShow(false)} />
                            </div>

                            <input type="checkbox" className="toggle" id="sale-option" onClick={() => handleSaleToggle(18, sellOption, saleValues, DPUValues)}></input>
                            <label htmlFor="sale-option" data-checked="Sell Far" data-unchecked="Sell Close"></label>

                            <input type="checkbox" className="toggle" id="supp-option" onClick={() => handleSupplyToggle(19, supplyOption, saleValues)}></input>
                            <label htmlFor="supp-option" data-checked="Steal Supplies" data-unchecked="Buy Supplies"></label>
                        </div>
                    </div>
                    <div>
                        {selectedDashboard.component}
                    </div>
                </div>
            </Fade>
        </section>
    )
}

export default BusinessStatsDashboard;